import * as Tabs from "@radix-ui/react-tabs"

import styles from "./CompanyAdmin.module.scss"

import AccountingTab from "@/company_admin/components/accounting/AccountingTab"
import { graphql } from "@/company_admin/gql/__generated__"
import { useCompanyAdminQuery } from "@/provider/apollo/Apollo"

export const GetCompanySalons = graphql(/* GraphQL */ `
	query GetCompanySalons($param: GetCompanySalonsParam!) {
		getCompanySalons(param: $param) {
			companyName
			salons {
				salonId
				salonName
			}
		}
	}
`)

enum MainTab {
	ACCOUNTING = "ACCOUNTING",
}

const CompanyAdminPage = () => {
	const { data: companySalonsData } = useCompanyAdminQuery(GetCompanySalons, {
		variables: { param: {} },
	})
	const companyName = companySalonsData?.getCompanySalons?.companyName ?? ""

	return (
		<div className={styles.company}>
			<h1 className={styles.page_title}>
				法人管理ページ{companyName ? ` - ${companyName}` : ""}
			</h1>
			<Tabs.Root defaultValue={MainTab.ACCOUNTING}>
				<Tabs.List className={styles.tabs_header}>
					<Tabs.Trigger value={MainTab.ACCOUNTING} className={styles.tab}>
						経理
					</Tabs.Trigger>
				</Tabs.List>
				<Tabs.Content value={MainTab.ACCOUNTING} className={styles.tab_content}>
					<AccountingTab />
				</Tabs.Content>
			</Tabs.Root>
		</div>
	)
}

export default CompanyAdminPage
